import {
	type FetchSocialMarketingBannersV2Params,
	getResponseStatusIfAxiosError,
	minutesToMs,
	socialApi,
	useLogger
} from '@capsicum/common';
import { useQuery } from '@tanstack/react-query';

type UseMarketingBannersQueryProps = {
	query: FetchSocialMarketingBannersV2Params;
};

export const MARKETING_BANNERS_QUERY_KEY = 'marketing-banners';

export const useMarketingBannersQuery = ({ query }: UseMarketingBannersQueryProps) => {
	const logger = useLogger();

	return useQuery({
		queryFn: async () =>
			(await socialApi).fetchSocialMarketingBannersV2(query, {
				customErrorInterceptor: e => {
					const statusCode = getResponseStatusIfAxiosError(e);

					if (statusCode?.toString().startsWith('5')) {
						logger.error('Error fetching marketing banners', e);

						return true;
					}

					return false;
				}
			}),
		queryKey: [MARKETING_BANNERS_QUERY_KEY, query],
		select: resp => resp.data,
		staleTime: minutesToMs(5)
	});
};
